import Axios from 'axios';
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

const CancelToken: any = Axios.CancelToken;
const URL: string = '/settings';
const ICON: string = '/icons';
let cancel: any;

// @ts-ignore
export class Setting extends Model<ISetting> implements ISetting {
  value!: any;
  key!: string;
  id!: number;
  type?: string;

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {...{id: null, key: '', value: ''}, ...attributes}, // Default values
      parentCollection,
    );
  }

  urlRoot(): string {
    return URL;
  }

  url(): string {
    return `${this.urlRoot()}/key/${this.key}`;
  }
}

export default class SettingCollection extends Collection<Setting> {

  routeName = 'Setting';
  model(): Constructor<Setting> {
    return Setting;
  }

  url(): string {
    return URL;
  }

  icons(): string {
    return ICON;
  }

  /*
   * Patch
   */
  update(id: any, data: any) {
    return axiosInstance.post(`${this.url()}/${id}`, {data})
      .then((response: any) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  updateDefaultBG(data: any) {
    return axiosInstance.post(`${this.url()}/defaultBG`, {data})
      .then((response: any) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  // system setting of configuration
  getSettings() {
    return axiosInstance.get(`${this.url()}`)
      .then((response: any) => response.data)
      .catch((e: any) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  // system setting of configuration
  getKeySetting(name: any) {
    return axiosInstance.get(`${this.url()}/key/${name}`)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  updateByKey(key: string, data: ISetting) {
    return axiosInstance.patch(`${this.url()}/key/${key}`, data)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  // system logo dynamic
  getSystemLogo() {
    return axiosInstance.get(`${this.url()}/logo`)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  /**
   * get default dashboard
   */
  getDashboard(name: any) {
    return axiosInstance.get(`${this.url()}/default/${name}/dashboard`)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  /**
   * set default dashboard
   */
  setDashboard(id: any) {
    return axiosInstance.post(`${this.url()}/default/dashboard/${id}`)
      .then((response) => response)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  /**
   * set default gf account
   */
  setGfAccount(id: any) {
    return axiosInstance.post(`${this.url()}/default/account/${id}`)
      .then((response) => response)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
  /**
   * set default user
   */
  setUser(id: any) {
    return axiosInstance.post(`${this.url()}/default/user/${id}`)
      .then((response) => response)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  fetchIcon(index: number | null, search: string | null, perpage: number | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (index === null) {
      index = 1;
    }

    if (search) {
      return axiosInstance.get(`${this.icons()}?search=${search}&page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: this.routeName,
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.icons()}?page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: this.routeName,
            message: e,
          };
          generateLog(log);
        });
    }
  }

  createIcon(data: any) {
    return axiosInstance.post(`${this.icons()}`, data)
      .then((response) => response)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  getIcon(id: any) {
    return axiosInstance.get(`${this.icons()}/${id}`)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  deleteIcon(ids: any) {
    return axiosInstance.delete(`${this.icons()}/${ids}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
}
